 
import {
  EmailOutlined,
  FacebookOutlined,
  LanguageOutlined,
  LinkedIn,
  PhoneOutlined,
  VisibilityOutlined,
} from "@mui/icons-material";
import {
  Box,
  Chip,
  Collapse,
  Grid,
  IconButton,
  Stack,
  Switch,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { IStoreState } from "../../../../redux/initialStoreState";
import { batch, useSelector } from "react-redux";
import { StandadCard } from "../../../../components/Cards";
import { useDispatchWrapper } from "../../../../hooks";
import {
  clearCustomerState,
  fetchCustomerRelAccountAsync,
  fetchPersonalInfoAsync,
} from "../../../../redux/customer/customerActions";
import { PageLoader } from "../../../../components/PageLoader/PageLoader";
import { LoadState } from "../../../../constants/enums";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import profilePhoto from "../../../../assets/user-1.jpg";
import { getFullAddres } from "../../../../helpers";
import { StatusRenderer } from "../../../../components/ActiveInActiveStatus/ActiveInActiveStatus";
import { CSS_CONSTANTS } from "../../../../constants/cssConstants";
import { EditCustomerRightPanel } from "../../EditCustomerRightPanel";
import { CustomerRelAccountsView } from "../CustomerRelAccounts/CustomerRelAccountsView";
import { CustomerOutstandingAging } from "../CustomerOutstandingAging/CustomerOutstandingAging";
import moment from "moment";

export const CustomerBaiscDetailsLayout: React.FC<{
  customerId?: string | number;
  fromPolicy: boolean;
  policyId?: number;
  children: React.ReactNode;
}> = (props) => {
  const { customerId, fromPolicy, policyId } = props;
  const navigate = useNavigate();
  const dispatch = useDispatchWrapper();
   const { pathname } = useLocation();

  const shouldHideIcon = !pathname.includes("customer-overview");
  const {
    personalInformation: { data, loading },
    error,
  } = useSelector((storeState: IStoreState) => storeState.customer);

  const [openEditCustomer, setOpenEditCustomer] = React.useState(false);
  const [overviewExpanded, setOverviewExpanded] = React.useState(!fromPolicy);

  const theme = useTheme();

  React.useEffect(() => {
    if (customerId) {
      batch(() => {
        dispatch(
          fetchPersonalInfoAsync(customerId as number, fromPolicy, policyId)
        );

        dispatch(
          fetchCustomerRelAccountAsync(
            customerId as number,
            fromPolicy,
            policyId
          )
        );
      });
    }
  }, [customerId, fromPolicy, policyId]);

  const handleNavigate = () => {
    navigate(`/customer-overview/${customerId}`);
  };

  const handleUrl = (url: string | null) => () => {
    if (url) {
      window.open(url, "_blank");
    }
  };

  React.useEffect(() => {
    return () => {
      dispatch(clearCustomerState());
    };
  }, []);

  return (
    <PageLoader
      loading={loading === LoadState.InProgress}
      error={
        error
          ? {
              message: error,
            }
          : null
      }
    >
      <Box>
        {data && (
          <Box>
            <Grid container spacing={1}>
              <Grid item xs={12} md={8}>
                <StandadCard sx={{ height: "100%" }}>
                  <Stack
                    direction={"row"}
                    sx={{
                      flexWrap: {
                        xs: "wrap",
                        md: "nowrap",
                      },
                    }}
                    spacing={2}
                  >
                    <Stack>
                      <Box
                        sx={{
                          height: "110px",
                          width: "110px",
                        }}
                      >
                        <img
                          src={profilePhoto}
                          alt="log not found"
                          style={{ height: "100%", borderRadius: "100px" }}
                        />
                      </Box>
                    </Stack>
                    <Stack width={"100%"}>
                      <Stack
                        direction={"row"}
                        justifyContent={"space-between"}
                        alignItems={"start"}
                      >
                        <Stack direction={"column"} spacing={0}>
                          <Typography
                            variant="body1"
                            fontSize={"1.5rem"}
                            fontWeight={600}
                          >
                            {data.customer_name + ` (${data.customer_code})`}
                          </Typography>
                          <Stack
                            spacing={2}
                            direction={"row"}
                            alignItems={"center"}
                          >
                            <Typography
                              variant="body1"
                              fontSize={CSS_CONSTANTS.LABEL_VALUE_SIZE}
                              fontWeight={600}
                              sx={{
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <Stack sx={{
                                    p: 1,
                                    mr: 1,
                                  borderRadius: "100%",
                                  backgroundColor: theme.palette.primary.light,
                                  cursor: data.facebook ? "pointer" : "auto",
                                  "&:hover": {
                                    boxShadow: theme.shadows["16"],
                                  },
                                  "& svg": { color: theme.palette.primary.main}
                              }}>
                              <EmailOutlined fontSize="small"  />
                               </Stack>
                              {data.email}
                            </Typography>
                               <Typography
                              variant="body1"
                              fontSize={CSS_CONSTANTS.LABEL_VALUE_SIZE}
                              fontWeight={600}
                              sx={{
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <Stack sx={{
                                    p: 1,
                                    mr: 1,
                                  borderRadius: "100%",
                                  backgroundColor: theme.palette.primary.light,
                                  cursor: data.facebook ? "pointer" : "auto",
                                  "&:hover": {
                                    boxShadow: theme.shadows["16"],
                                  },
                                  "& svg": { color: theme.palette.primary.main}
                              }}>
                              <PhoneOutlined fontSize="small"  />
                              </Stack>
                              {data.mobile || data.phone}
                            </Typography>
                          </Stack>

                          <Stack
                            direction={"row"}
                            alignItems={"center"}
                            spacing={1}
                          >
                            <StatusRenderer status={data.status} />
                            <Typography
                              variant="body1"
                              fontSize={"1rem"}
                              fontWeight={600}
                            >
                              {" "}
                              {`Customer Since: ${
                                data.customer_since
                                  ? moment(data.customer_since).format(
                                      "MMM d, yyyy"
                                    )
                                  : "N/A"
                              }`}
                            </Typography>
                            {!overviewExpanded && (
                              <Stack direction={"row"} spacing={0.5}>
                                {data.producer_code && (
                                  <Chip
                                    size="small"
                                    label={`Producer: ${data.producer_code}`}
                                    sx={{ fontSize: "0.7rem", height: 22 }}
                                  />
                                )}
                                {data.branch_code && (
                                  <Chip
                                    size="small"
                                    label={`Branch: ${data.branch_code}`}
                                    sx={{ fontSize: "0.7rem", height: 22 }}
                                  />
                                )}
                              </Stack>
                            )}
                            {overviewExpanded && (
                            <>
                            <Tooltip
                              title={
                                <Stack>
                                  <Typography
                                    variant="body1"
                                    fontSize={CSS_CONSTANTS.LABEL_HEADING_SIZE}
                                    fontWeight={600}
                                  >
                                    Website
                                  </Typography>
                                  <Typography variant="body1" fontWeight={600}>
                                    {data.website || "N/A"}
                                  </Typography>
                                </Stack>
                              }
                            >
                              <Stack
                                sx={{
                                  p: 1,
                                  borderRadius: "100%",
                                  backgroundColor: theme.palette.primary.light,
                                  cursor: data.website ? "pointer" : "auto",
                                  "&:hover": {
                                    boxShadow: theme.shadows["16"],
                                  },
                                }}
                                onClick={handleUrl(data.website)}
                              >
                                <LanguageOutlined
                                  sx={{ color: "primary.main" }}
                                  fontSize="small"
                                />
                              </Stack>
                            </Tooltip>
                            <Tooltip
                              title={
                                <Stack>
                                  <Typography
                                    variant="body1"
                                    fontSize={CSS_CONSTANTS.LABEL_HEADING_SIZE}
                                    fontWeight={600}
                                  >
                                    Facebook
                                  </Typography>
                                  <Typography variant="body1" fontWeight={600}>
                                    {data.facebook || "N/A"}
                                  </Typography>
                                </Stack>
                              }
                            >
                              <Stack
                                sx={{
                                  p: 1,
                                  borderRadius: "100%",
                                  backgroundColor: theme.palette.success.light,
                                  cursor: data.facebook ? "pointer" : "auto",
                                  "&:hover": {
                                    boxShadow: theme.shadows["16"],
                                  },
                                }}
                                onClick={handleUrl(data.facebook)}
                              >
                                <FacebookOutlined
                                  sx={{ color: "primary.main" }}
                                  fontSize="small"
                                />
                              </Stack>
                            </Tooltip>
                            <Tooltip
                              title={
                                <Stack>
                                  <Typography
                                    variant="body1"
                                    fontSize={CSS_CONSTANTS.LABEL_HEADING_SIZE}
                                    fontWeight={600}
                                  >
                                    LinkedIn
                                  </Typography>
                                  <Typography variant="body1" fontWeight={600}>
                                    {data.linkedin || "N/A"}
                                  </Typography>
                                </Stack>
                              }
                            >
                              <Stack
                                sx={{
                                  p: 1,
                                  borderRadius: "100%",
                                  backgroundColor: theme.palette.warning.light,
                                  cursor: data.linkedin ? "pointer" : "auto",
                                  "&:hover": {
                                    boxShadow: theme.shadows["16"],
                                  },
                                }}
                                onClick={handleUrl(data.linkedin)}
                              >
                                <LinkedIn
                                  sx={{ color: "primary.main" }}
                                  fontSize="small"
                                />
                              </Stack>
                            </Tooltip>
                            </>
                            )}
                          </Stack>
                        </Stack>
                        <Stack direction={"row"} spacing={1} alignItems={"center"}>
                          <Tooltip
                            title={overviewExpanded ? "Collapse" : "Expand"}
                            arrow
                          >
                            <Switch
                              checked={overviewExpanded}
                              onChange={() =>
                                setOverviewExpanded((prev) => !prev)
                              }
                            />
                          </Tooltip>
                       {shouldHideIcon && (
                          <Tooltip title="View Profile" arrow>
                            <IconButton
                              onClick={handleNavigate}
                              sx={{
                                backgroundColor: theme.palette.primary.main,
                                "&:hover":{
                                    backgroundColor: theme.palette.primary.main,
                                }
                              }}
                            >
                              <VisibilityOutlined
                                sx={{
                                  color: '#fff',
                                }}
                              />
                            </IconButton>
                          </Tooltip>
                       )}
                          <Tooltip
                            title="Edit Profile"
                            arrow
                            onClick={() => setOpenEditCustomer(true)}
                          >
                            <IconButton
                              sx={{
                                backgroundColor: theme.palette.primary.main,
                                "&:hover":{
                                    backgroundColor: theme.palette.primary.main,
                                }
                              }}
                            >
                              <EditOutlinedIcon
                                sx={{
                                  color: '#fff',
                                }}
                              />
                            </IconButton>
                          </Tooltip>
                        </Stack>
                      </Stack>
                    </Stack>
                  </Stack>
                  <Collapse in={overviewExpanded} timeout="auto" unmountOnExit>
                  <Grid container mt={1} spacing={1}>
                     <Grid item xs={12} md={3}>
                      <Typography
                        variant="body1"
                        fontSize={CSS_CONSTANTS.LABEL_VALUE_SIZE}
                        fontWeight={400}
                      >
                        Goes By
                      </Typography>
                      <Typography
                        variant="body1"
                        fontSize={CSS_CONSTANTS.LABEL_VALUE_SIZE}
                        fontWeight={600}
                      >
                        {data.goes_by}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <Typography
                        variant="body1"
                        fontSize={CSS_CONSTANTS.LABEL_VALUE_SIZE}
                        fontWeight={400}
                      >
                        Phone
                      </Typography>
                      <Typography
                        variant="body1"
                        fontSize={CSS_CONSTANTS.LABEL_VALUE_SIZE}
                        fontWeight={600}
                      >
                        {data.phone}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <Typography
                        variant="body1"
                        fontSize={CSS_CONSTANTS.LABEL_VALUE_SIZE}
                        fontWeight={400}
                      >
                        Position
                      </Typography>
                      <Typography
                        variant="body1"
                        fontSize={CSS_CONSTANTS.LABEL_VALUE_SIZE}
                        fontWeight={600}
                      >
                        {data.position}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <Typography
                        variant="body1"
                        fontSize={CSS_CONSTANTS.LABEL_VALUE_SIZE}
                        fontWeight={400}
                      >
                        Branch
                      </Typography>
                      <Typography
                        variant="body1"
                        fontSize={CSS_CONSTANTS.LABEL_VALUE_SIZE}
                        fontWeight={600}
                      >
                        {data.branch_code}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <Typography
                        variant="body1"
                        fontSize={CSS_CONSTANTS.LABEL_VALUE_SIZE}
                        fontWeight={400}
                      >
                        Producer
                      </Typography>
                      <Typography
                        variant="body1"
                        fontSize={CSS_CONSTANTS.LABEL_VALUE_SIZE}
                        fontWeight={600}
                      >
                        {data.producer_code}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <Typography
                        variant="body1"
                        fontSize={CSS_CONSTANTS.LABEL_VALUE_SIZE}
                        fontWeight={400}
                      >
                        CSR
                      </Typography>
                      <Typography
                        variant="body1"
                        fontSize={CSS_CONSTANTS.LABEL_VALUE_SIZE}
                        fontWeight={600}
                      >
                        {data.csr_code}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <Typography
                        variant="body1"
                        fontSize={CSS_CONSTANTS.LABEL_VALUE_SIZE}
                        fontWeight={400}
                      >
                        Marketer
                      </Typography>
                      <Typography
                        variant="body1"
                        fontSize={CSS_CONSTANTS.LABEL_VALUE_SIZE}
                        fontWeight={600}
                      >
                        {data.marketer_code}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <Typography
                        variant="body1"
                        fontSize={CSS_CONSTANTS.LABEL_VALUE_SIZE}
                        fontWeight={400}
                      >
                        Assigned To
                      </Typography>
                      <Typography
                        variant="body1"
                        fontSize={CSS_CONSTANTS.LABEL_VALUE_SIZE}
                        fontWeight={600}
                      >
                        {data.assigned_to_code}
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography
                        variant="body1"
                        fontSize={CSS_CONSTANTS.LABEL_VALUE_SIZE}
                        fontWeight={400}
                      >
                        Address
                      </Typography>
                      <Typography
                        variant="body1"
                        fontSize={CSS_CONSTANTS.LABEL_VALUE_SIZE}
                        fontWeight={600}
                      >
                        {getFullAddres(
                          data.mailing_address,
                          data.unit_or_suite,
                          data.city,
                          data.province_or_state,
                          data.country,
                          data.postal_code
                        )}
                      </Typography>
                    </Grid>
                  </Grid>
                  </Collapse>

                  {/* </Grid>
                </Grid> */}
                </StandadCard>
              </Grid>
              <Grid item xs={12} md={4}>
                <CustomerRelAccountsView customerId={customerId as number} />
              </Grid>

              <Grid item xs={12} sx={{ transform: "scaleY(0.95)", transformOrigin: "top" }}>
                <Collapse in={overviewExpanded} timeout="auto" unmountOnExit>
                  <CustomerOutstandingAging customerId={customerId as number} customerCode={data.customer_code || ""} />
                </Collapse>
              </Grid>
            </Grid>
          </Box>
        )}

        {props.children}
      </Box>
      {openEditCustomer && customerId && (
        <EditCustomerRightPanel
          open={openEditCustomer}
          customer_id={customerId as number}
          onClose={() => setOpenEditCustomer(false)}
          onComplete={() => setOpenEditCustomer(false)}
        />
      )}
    </PageLoader>
  );
};
